
<template>
  <div id="app" class="container">
    <br />
    <br />

    <div>
      <div class="row">
        <div class="col-xs-12 text-left" style="margin-top:30px;">
          <div v-if="projectLogo" class="text-right" style="float: left !important;">
            <img :src="projectLogo" class="resize-project-logo-lg" />
          </div>
          <div style="float: left; font-size: 12px; font-family: Times New Roman, Times, serif;">
            Công ty CP TM Thùy Dương - Đức Bình
            <br />18E Cộng Hòa, Phường 4, Quận Tân Binh TPHCM
            <br />MST: 0201240971
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-center"
      style="background-color:#168AD6;font-size: 20px; font-family: Times New Roman, Times, serif; 
      font-weight: bold; text-transform: uppercase;margin-top:15px;color:white;"
    >XÁC NHẬN THANH TOÁN</div>
    <div
      class="text-center"
      style="font-size: 16px; font-family: Times New Roman, Times, serif; text-transform: uppercase;"
    >
      <i>PAYMENT CONFIRMATION</i>
    </div>
    <div class="text-center" style="font-size: 12px; font-family: Times New Roman, Times, serif; ">
      Số /
      <i>No.</i>:
      <b>{{receipt_data.receipt_code}}</b>
    </div>

    <div class="container" style="margin-top:30px;">
      <div class="row">
        <table
          class="table table-condensed"
          style="width:80%; border:0px solid red; margin-left : 10%"
        >
          <tbody>
            <tr>
              <td style="width:20%">
                <b>Ngày</b> /
                <i>Date</i>:
              </td>
              <td style="width:40%">
                <b class="text-uppercase" style="text-align:left;">{{receipt_data.date_created}}</b>
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Ngày Chứng Từ</b> /
                <i>Date Invoice</i>:
              </td>
              <td style="width:60%">
                <b class="text-uppercase" style="text-align:left;">{{receipt_data.record_date}}</b>
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Họ và tên người nộp tiền:</b>
                <br />
                <i>Name of Payment Applicant</i>
              </td>
              <td style="width:60%; text-transform: uppercase;">{{receipt_data.resident_fullname}}</td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Hình thức thanh toán:</b>
                <br />
                <i>Type of payment</i>:
              </td>
              <td style="width:40%">
                <b>Chuyển Khoản</b>
                <br />
                <i>Bank transfer</i>
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Số tiền:</b>
                <br />
                <i>Total Amount</i>:
              </td>
              <td style="width:60%">
                {{formatNumber(receipt_data.actual_amount)}} VNĐ
                <br />
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Bằng chữ:</b>
                <br />
                <i>In Words</i>:
              </td>
              <td style="width:60%">
                <b>{{readMoney(receipt_data.actual_amount, "vi")}} ./.</b>
                <br />
                <i>{{readMoney(receipt_data.actual_amount, "en")}} ./.</i>
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Nội dung</b>
                <br />
                <i>Description</i>:
              </td>
              <td style="width:40%">
                Republic Plaza xác nhận đã nhận được tiền thanh toán dịch vụ
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <table class="table table-condensed" style="border:0px; margin-left:5% ">
          <tr>
            <th class="text-center">
              <b>Người lập phiếu</b>
              <br />
              <i class="table_column_en">Drafted by</i>
            </th>
            <th class="text-center">
              Thủ quỹ
              <br />
              <i class="table_column_en">Cashier</i>
            </th>
            <th class="text-center">
              Kế toán trưởng
              <br />
              <i class="table_column_en">Chief Accountant</i>
            </th>
            <th class="text-center">
              Thủ trưởng đơn vị
              <br />
              <i class="table_column_en">Director</i>
            </th>
          </tr>

          <br />
          <br />
          <br />

          <tr>
            <th class="text-center">{{receipt_data.user_created_full_name}}</th>
            <th class="text-center"></th>
            <th class="text-center"></th>
            <th class="text-center"></th>
          </tr>
        </table>
      </div>
    </div>

    <br />
    <div class="row">
      <form class="form-horizontal">
        <div class>
          <button
            id="cmdCancel"
            type="button"
            class="btn btn-labeled btn-danger"
            @click="CancelInvoiceList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label">
              <i class="fa fa-mail-reply"></i>
            </span>
            {{$t('common.back')}}
          </button>
          <button
            id="cmdPrintPdf"
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="printInvoice"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{$t('common.printPdf')}}
          </button>
        </div>
      </form>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
// import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
import utils from "@/lib/utils";
import i18n from "../../lang";

export default {
  name: "ReceiptPdf_CK",
  data() {
    return {
      projectLogo: null,
      ishow: false,
      receipt_data: {
        id: 0,
        receipt_code: "",
        expected_amount: 0,
        expected_amount_show: 0,
        actual_amount: 0,
        user_created: "",
        user_created_full_name: "",
        date_created: new Date(),
        excess_cash: 0,
        payments_type: 1,
        invoice_id: 0,
        monthy_services: [],
        receipt_monthy_services_name: "",
        resident_fullname: "",
        apartment_code: "",
        month: "",
        record_date: "",
        amount: ""
      }
    };
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    formatNumber: function(amount) {
      return utils.formatNumber(amount);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_RECEIPT_DETAIL",
      "GET_RECEIPT_EXPLAINATION_BY_RECEIPT_ID"
    ]),

    readMoney: function(number, locale) {
      return utils.readMoney(number, locale);
    },
    CancelInvoiceList: function() {
      this.$router.push({
        name: "ReceiptList"
      });
    },

    onConfirm: function() {
      this.isModalVisible = false;
    },

    printInvoice: function() {
      document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },

    convertDateVN(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return "Ngày " + day + " tháng " + month + " năm " + year;
    },
    convertDateMonth(date) {
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return " tháng " + month + " năm " + year;
    },
    convertDateEN(date) {
      return utils.formatSqlDate(date, null, "DD MMM YYYY");
    },

    formatTotalFee(total_fee, isFormat = false) {
      if (total_fee != undefined) {
        total_fee = utils.makeRoundNumber(total_fee);
        let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return rs == 0 && isFormat ? "-" : rs;
      }
    }
  },
  async mounted() {
    // Add or Update data
    let id = this.$route.params.id;
    let amount = 0;
    let actual_amount = 0
    let is_zero_amount = false
    this.projectLogo = sessionStorage.getItem('projectLogo')
    if (parseInt(id) !== 0) {
      await this.GET_RECEIPT_EXPLAINATION_BY_RECEIPT_ID({ id: id })
        .then(
          function(res) {
            for (let i = 0; i < res.length; i++) {
              if (res[i].amount == 0) {
                is_zero_amount = true
              }
              if (!is_zero_amount) {
                actual_amount += res[i].amount
              }
            }

            this.GET_RECEIPT_DETAIL({ id: id }).then(
              function(res) {
                if (is_zero_amount) {
                  actual_amount = res.amount
                }
                // monthy_services
                this.receipt_data.id = res.id;
                this.receipt_data.receipt_code = res.receipt_code;
                //this.receipt_data.expected_amount = res.expected_amount;
                this.receipt_data.amount = amount;
                this.receipt_data.expected_amount = res.amount;
                // this.receipt_data.expected_amount_show = this.formatTotalFee(
                //   res.expected_amount
                // );
                this.receipt_data.expected_amount_show = this.formatTotalFee(
                  res.amount
                );
                // this.receipt_data.expected_amount_show = this.formatTotalFee(
                //   amount > res.amount ? amount : res.amount
                // );
                if (
                  this.receipt_data.amount > this.receipt_data.expected_amount
                ) {
                  this.ishow = true;
                  this.receipt_data.amount =
                    utils.formatNumber(res.amount) +
                    " Đã thanh toán từ số tiền " +
                    this.receipt_data.expected_amount_show +
                    " dư có còn lại " +
                    utils.formatNumber(
                      this.receipt_data.amount - this.receipt_data.expected_amount
                    );
                }
                this.receipt_data.actual_amount = actual_amount
                this.receipt_data.excess_cash = this.formatTotalFee(
                  res.actual_amount - res.expected_amount
                );

                this.receipt_data.user_created = res.user_created;
                this.receipt_data.user_created_full_name = utils.getFullName(
                  res.user_first_name,
                  res.user_last_name,
                  i18n.locale
                );
                this.receipt_data.resident_fullname =
                  res.apartment.owner_apartment;
                this.receipt_data.date_created = utils.formatSqlDate(res.date_created, null, "DD/MM/YYYY");

                this.receipt_data.payments_type = res.receipt_type;
                //this.receipt_data.receipt_monthy_services_name =
                //  res.receipt_monthy_services_name.name;
                this.receipt_data.invoice_id = res.invoice;
                this.receipt_data.apartment_code = res.apartment.apartment_code;
                this.receipt_data.month = utils.formatSqlDate(res.date_created, null, "MM");
                this.receipt_data.record_date = utils.formatSqlDate(res.due_date, null, "DD/MM/YYYY");
              }.bind(this)
            )
          }.bind(this)
        )
        .then()
        .then();

      await utils.sleep(1000);
      //this.printInvoice();
    } else {
      // ERROR
    }
  },
  components: {}
};
</script>

<style scoped>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 2px solid #000000;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 2px solid #000000;
}

.container {
  font-family: Times New Roman, Times, serif !important;
}

body {
  font-size: 12px !important;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 80px;
  max-height: 60px;
}
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
/* remove title when print */
@page {
  size: auto;
  margin: 0mm;
}

.table_column_en {
  font-style: italic;
  font-weight: 100;
}

table {
  border: 1px solid #ccc;
  border-collapse: collapse;
}

td {
  border-top: 0px solid !important;
}
</style>




// WEBPACK FOOTER //
// src/views/Receipt/ReceiptPdf_CK.vue